
export const DEV_MODE = false; //change here to local


export const permissionTypes = [{value: 0, label: "Dateien ansehen"}, {value: 1, label: "Dateien und Accounts bearbeiten"}];

export const backendPathAuth = DEV_MODE ? "http://127.0.0.1:8000/auth/functions/" : "https://mitarbeiter.intranet.betreuung-mit-herz.org/backend/auth/functions/";
export const backendPathUsers = DEV_MODE ? "http://127.0.0.1:8000/users/" : "https://mitarbeiter.intranet.betreuung-mit-herz.org/backend/users/";
export const backendPathStoring = DEV_MODE ? "http://127.0.0.1:8000/storing/" : "https://mitarbeiter.intranet.betreuung-mit-herz.org/backend/storing/";
